<template>
  <div class="app-main">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup>
</script>

<style scoped lang="less">
.app-main {
  width: 100%;

  ::-webkit-scrollbar {
    width: 10px;
    height: 5px;
  }

  :hover::-webkit-scrollbar-thumb {
    border-radius: 30px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #dedfe1;
  }
}
</style>
